module.exports = __webpack_public_path__ + "img/dsci0033.48850478.jpg";